import script from "./ContactSendSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSendSection.vue?vue&type=script&setup=true&lang=js"

import "./ContactSendSection.vue?vue&type=style&index=0&id=efd145d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd145d2"]])

export default __exports__